import { Tabs } from 'antd';

interface MTabsProps {
  items: Array<{
    key: string;
    label: string;
    children: React.ReactNode;
  }>;
  className?: string;
}

export const MTabs = ({ items, className }: MTabsProps) => {
  return <Tabs items={items} className={className} />;
};
